/**
 * Walkthrough copy — English-only today; keys are i18n-ready for future locales.
 * @module features/walkthrough/i18n/walkthroughI18n
 */

import en from '../content/en.json';

/** @type {Record<string, unknown>} */
const MESSAGES_BY_LOCALE = Object.freeze({
  en,
});

const DEFAULT_LOCALE = 'en';

/**
 * @param {string} key Dot path, e.g. `walkthrough.employee.submit.title`
 * @param {Record<string, string | number>} [params] `{{name}}` interpolation values
 * @returns {string}
 */
export function t(key, params = {}) {
  const parts = key.split('.');
  let value = MESSAGES_BY_LOCALE[DEFAULT_LOCALE];

  for (const part of parts) {
    if (value == null || typeof value !== 'object') {
      value = undefined;
      break;
    }
    value = value[part];
  }

  if (typeof value !== 'string') {
    if (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production') {
      console.warn(`[walkthrough i18n] Missing key: ${key}`);
    }
    return key;
  }

  return value.replace(/\{\{(\w+)\}\}/g, (_, name) =>
    params[name] !== undefined ? String(params[name]) : `{{${name}}}`
  );
}

/**
 * @param {string} tourId
 * @returns {{ title: string, description: string }}
 */
export function tourMeta(tourId) {
  return {
    title: t(`walkthrough.tours.${tourId}.title`),
    description: t(`walkthrough.tours.${tourId}.description`),
  };
}
